import React from 'react';
import { createRoot } from 'react-dom/client';
import 'assets/css/App.css';
import { HashRouter, Route, Switch, Redirect } from 'react-router-dom';
import { ChakraProvider } from '@chakra-ui/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import AuthLayout from 'layouts/auth';
import AdminLayout from 'layouts/admin';
import theme from 'theme/theme';
import { AuthProvider } from 'contexts/AuthContext';

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			retry: 1,
			refetchOnWindowFocus: false,
			staleTime: 30_000,
		},
	},
});

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
	<ChakraProvider theme={theme}>
		<React.StrictMode>
			<QueryClientProvider client={queryClient}>
				<AuthProvider>
					<HashRouter>
						<Switch>
							<Route path={`/auth`} component={AuthLayout} />
							<Route path={`/admin`} component={AdminLayout} />
							<Redirect from='/' to='/admin/overview' />
						</Switch>
					</HashRouter>
				</AuthProvider>
			</QueryClientProvider>
		</React.StrictMode>
	</ChakraProvider>
);
